import type { DealEmbed } from '../../lib/embeds/types';

export function DealCard({ link, price, title, image }: DealEmbed) {
  return (
    <a
      className="embed embed-deal"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        border: '2px solid #ff5a00',
        borderRadius: 12,
        padding: 14,
        textDecoration: 'none',
        background: '#fff'
      }}
    >
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={{ color: '#111827', fontWeight: 600, fontSize: 15 }}>
          {title || 'Limited offer'}
        </div>
        <div style={{ color: '#ef4444', fontWeight: 700, fontSize: 16 }}>${price}</div>
      </div>
      {image ? (
        <img
          src={image}
          alt={title || 'Deal image'}
          style={{
            width: 72,
            height: 72,
            objectFit: 'cover',
            borderRadius: 10,
            border: '1px solid #f3f4f6'
          }}
        />
      ) : null}
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 14px',
          borderRadius: 10,
          background: '#ff5a00',
          color: '#fff',
          fontWeight: 600,
          fontSize: 14,
          width: 'fit-content'
        }}
      >
        View deal
      </div>
    </a>
  );
}
